<template>
  <el-select filterable v-model="formatCountry" style="width: 100%;" placeholder="Select" disabled
    @change="handleChangeCountry">
    <el-option v-for="item in mappedCountryList" :key="item.value" :label="item.label" :value="item.value" />
  </el-select>
</template>

<script>
import { getLocationByCountry,addLocationByCountry,delLocationByCountry } from "@/services/modules";
import { SGP_COUNTRY } from "@/constants.js";
export default {
  name: 'JobLocationSelector',
  props: {
    disabled:{
      type: Boolean,
      default: false
    },
    schedulFormData: Object,
  },
  data(){
    return {
      SGP_COUNTRY,
      locationList: this.$store.state.locationList,
      sgpLocationList: this.$store.state.sgpLocationList,
      otherLocationList:[],
      mappedCountryList: this.$store.state.mappedCountryList,
    }
  },
  watch: {

  },
  computed:{
    isSingapore(){
      return this.schedulFormData.country === "SGP" || !this.schedulFormData.country;
    },
    formatCountry:{
      get(){
        return this.schedulFormData.timezone ?? this.SGP_COUNTRY.timezone;
        // return this.SGP_COUNTRY.timezone;
      },
      set(val) {
        // this.schedulFormData.timezone = val 
        // this.$emit('handleChangeCountry',this.schedulFormData.timezone)
      }
    }
  },
  mounted(){
    this.schedulFormData.country =  this.schedulFormData.country ?  this.schedulFormData.country : "SGP"
  },
  methods:{
    handleChangeCountry(){

    },
  }
}

</script>
<style lang="scss" scoped>

</style>
